import React from 'react'
import Header from '../Header/Header'
import IngredientesData from '../../Components/Admin/IngredientesData/IngredientesData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
export default function Ingredientes() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <IngredientesData />
                </div>
            </section>
        </div>
    )
}

